import script from "./CardFontList.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFontList.vue?vue&type=script&setup=true&lang=js"

import "./CardFontList.vue?vue&type=style&index=0&id=6b61888a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b61888a"]])

export default __exports__